import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
const SaveRoute = (props) => {
    let location = useLocation();
    let navigate = useNavigate();
    // if (props.truthy)
    // return props.children;
    // else return <Navigate to={props.safePath} state={{ from: location }} replace />;
    useEffect(() => {
        if (!props.truthy)
            navigate(props.safePath, { state: { from: location }, replace: true });
    }, [props.truthy]);
    return props.truthy ? props.children : null;
};
export default SaveRoute;
